import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSelector } from 'react-redux';

import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import { RESULTS_TYPE } from 'dpl/constants/query_params';
import MobileMenu from 'dpl/components/MobileMenu';
import Icon from 'dpl/common/components/Icon';

import useSearchFiltering from '../hooks/useSearchFiltering';
import SearchFilters from './SearchFilters';
import MobileFilterButtons from './MobileFilterButtons';

const IS_BOT_UA = window.__DPL_BOT_UA;

export default function MobileFilterMenu({
  totalItemCount,
  isMenuOpen,
  setIsMenuOpen
}) {
  const { isFiltersModalOpen, toggleFilters } = useSearchFiltering();
  const queryParams = useSelector(state => state.queryParams);

  const initialResultType = IS_BOT_UA
    ? RESULTS_TYPES.BREEDERS
    : RESULTS_TYPES.PUPPIES;
  const resultsType = queryParams[RESULTS_TYPE] || initialResultType;

  const isModalOpen = setIsMenuOpen ? isMenuOpen : isFiltersModalOpen;
  const setModalOpen = setIsMenuOpen || toggleFilters;

  return (
    <>
      <div
        className={classnames(
          'scrim--black fixed z-max left-0 top-0 right-0 bottom-0 transition pointer-events-none',
          {
            'o-0': !isModalOpen,
            'o-100': isModalOpen
          }
        )}
      />
      <MobileMenu
        className="pv4 no-scrollbars"
        position="bottom"
        isOpen={isModalOpen}
        footer={
          <MobileFilterButtons
            className="ph4 pv6 ph12-sm"
            setIsMenuOpen={() => setModalOpen(false)}
            totalItemCount={totalItemCount}
            resultsType={resultsType}
          />
        }
      >
        <div className="MobileFilterMenu flex flex-column bg-white min-h-100 overflow-y-auto">
          <div className="bb br--top b--light-gray flex items-center br3 justify-between fw-medium pt6 pb4 ph4 mb8">
            <p className="font-30 font-serif">
              Filter Results ({totalItemCount})
            </p>
            <button
              type="button"
              onClick={() => setModalOpen(false)}
              data-test-id="mobileFiltersToggleOff"
              className="ba br-100 b--default dib pv2 ph2"
            >
              <Icon name="fetch-close" width="16px" height="16px" />
            </button>
          </div>
          <SearchFilters />
        </div>
      </MobileMenu>
    </>
  );
}

MobileFilterMenu.propTypes = {
  totalItemCount: PropTypes.number.isRequired,
  setIsMenuOpen: PropTypes.func,
  isMenuOpen: PropTypes.bool
};

MobileFilterMenu.defaultProps = {
  setIsMenuOpen: null,
  isMenuOpen: false
};
